import type { MainMenuItemType } from '#base/core/types/MainMenuItemType';

export default (menuType: 'desktop' | 'mobile' = 'desktop'): MainMenuItemType[] => {
	const items: MainMenuItemType[] = [];

	if (menuType === 'mobile') {
		items.push({
			text: 'Home',
			to: {
				title: 'Fit Hier homepage',
				url: '/',
				newTab: false,
			},
		});
	}

	items.push({
		text: 'Fysiotherapie',
		to: {
			title: 'Fysiotherapie Uden',
			url: '/fysiotherapie',
			newTab: false,
		},
	});

	items.push({
		text: 'Behandelingen',
		to: {
			title: 'Fysio behandelingen',
			url: '/fysiotherapie/behandelingen',
			newTab: false,
		},
		submenu: {
			items: [
				{
					text: 'Shockwave therapie',
					description: 'Shockwave therapie is een geavanceerde behandelvorm voor pees- en spierblessures.',
					icon: 'fa-wave-square',
					to: {
						title: 'Fysio behandeling shockwave therapie',
						url: '/fysiotherapie/behandelingen/shockwave-therapie',
					},
				},
				{
					text: 'Dry needling',
					description: 'Dry needling verhelpt triggerpoints in de spieren om spierspanning weg te nemen.',
					icon: 'fa-arrows-to-dot',
					to: {
						title: 'Fysio behandeling dry needling',
						url: '/fysiotherapie/behandelingen/dry-needling',
					},
				},
				{
					text: 'Medical Taping',
					description: 'Medical taping ondersteund de spieren en gewrichten met speciale elastische tape.',
					icon: 'fa-dumbbell',
					to: {
						title: 'Fysio behandeling medical taping / sport taping',
						url: '/fysiotherapie/behandelingen/medical-taping-sporttape',
					},
				},
				{
					text: 'Sportrevalidatie',
					description: 'Sportrevalidatie is gericht op het herstellen van atleten tijdens en na blessures.',
					icon: 'fa-tape',
					to: {
						title: 'Fysio behandeling sportrevalidatie',
						url: '/fysiotherapie/behandelingen/sportrevalidatie',
					},
				},
				{
					text: 'Pre- en postoperatieve begeleiding',
					description: 'Pre- en postoperatieve begeleiding is een cruciaal proces vooraf én na je operatie.',
					icon: 'fa-hand-holding-medical',
					to: {
						title: 'Pre- en postoperatieve begeleiding',
						url: '/fysiotherapie/behandelingen/pre-post-operatieve-begeleiding',
					},
				},
				{
					text: 'Zwangerschapsklachten',
					description: 'Gespecialiseerde begeleiding tijdens en/of na je zwangerschap.',
					icon: 'fa-baby-carriage',
					to: {
						title: 'Fysiotherapie bij zwangerschapsklachten',
						url: '/fysiotherapie/behandelingen/fysiotherapie-zwangerschapsgerelateerde-klachten',
					},
				},
				{
					text: 'Hardloopanalyse',
					description: 'Tijdens een hardloopanalyse observeert de therapeut de manier waarop je rent.',
					icon: 'fa-person-running',
					to: {
						title: 'Hardloopanalyse',
						url: '/fysiotherapie/behandelingen/hardloopanalyse',
					},
				},
			],
			banner: {
				title: 'Loop niet langer rond met je klachten dan nodig!',
				image: {
					src: '/img/fysio/hielpijn_01.png',
					alt: 'Last van de hiel',
					width: 826,
					height: 466,
				},
				to: {
					url: '?d=afspraak-inplannen',
					title: 'Plan een afspraak fysiotherapie',
				},
				buttonText: 'Plan een afspraak',
			},
		},
	});

	items.push({
		text: 'Team',
		to: {
			title: 'Het Fysio Hier team',
			url: '/team',
			newTab: false,
		},
	});

	items.push({
		text: 'Vacatures',
		counter: countVacancies('fysio'),
		to: {
			title: 'Werken bij Fysio Hier',
			url: 'https://werkhier.com',
			newTab: true,
		},
	});

	return items;
};
